<template>
    <div class="vue-template">
        <!-- <img :src="imageUrl ? imageUrl : null" />
        <br> -->
        <h3>Attendance Ledger</h3><br>
        <form @submit.prevent="validateUserId()">
            <div class="form-group">
                <label>Please enter User ID</label>
                <input type="userId" class="form-control form-control-lg" v-model="userId" />
            </div>

            <button type="submit" :disabled="checkinDisabled" class="btn btn-dark btn-lg btn-block">Time Entry</button>

        </form>
    </div>
</template>



<script>
import firebase from "firebase/app"
import 'firebase/auth'
import axios from "axios"
//import ScaleLoader from "@/components/ScaleLoader"

import { Plugins, CameraSource, CameraDirection, CameraResultType } from "@capacitor/core";
const { Camera } = Plugins
const { Geolocation } = Plugins

export default {
    name: "GetCheckin",

    components: {
    },
      
    data() {
      return {
        msg: "",
        deviceUser: "",
        deviceUserToken: "",

        // Checkin User
        userId: '',

        imageUrl: null,
        location: {'lat': '0', 'long': '0'},

      };
    },

    created() {
      // firebase.auth().onAuthStateChanged((user) => {
      //   if (user) {
      //     this.deviceUser = user
      //     //console.log("User:" + JSON.stringify(user))
      //     this.$parent.userName = user.email
      //   } else {
      //     this.deviceUser = null;
      //     this.$router.push('/login')
      //   }
      //})
    },

    activated() {
    },

    beforeMount: function () {
    }, 
    
    mounted: function(){
      this.getLocation()
      this.checkLogIn()
    },

    computed: {
        // checkin button is enabled when userId is entered.
        checkinDisabled: function () {
        if (this.userId.trim()=="")
          return true
        else
          return false
      }
    },

    methods: {
        checkLogIn () {
          var self = this

          firebase.auth().onAuthStateChanged(function (user) {
            if (!user) {
              self.$router.push('/')
            }
          })
        },

        async getLocation() {
          console.log("In getLocation")
          if (this.$parent.onlineStatus == 'OnLine'){
            let location = await Geolocation.getCurrentPosition({
              enableHighAccuracy: true,
              timeout: 30000,
            });

            this.location["lat"] = location.coords.latitude.toString()
            this.location["long"] = location.coords.longitude.toString()
          }
        },

        async takePicture() {
          var self = this
          let isAvailable = true;

          if (!isAvailable) {
            // Have the user upload a file instead
            //alert("No Camera Aailable");
            self.$router.push({name:"SendCheckin", 
                            params: { "deviceUserToken": self.deviceUserToken,
                                      "userId": self.userId.trim(),
                                      "imgB64": '',
                                      "lat": self.location["lat"],
                                      "long": self.location["long"],
                                    } 
                          })
          } else {
            try {
              const image = await Camera.getPhoto({
                quality: 90,
                allowEditing: false,
                resultType: CameraResultType.Base64,
                //resultType: CameraResultType.DataUrl,
                source: CameraSource.Camera,
                direction: CameraDirection.Front,
                presentationStyle: "popover",
              });

              // image.base64_data will contain the base64 encoded result as a JPEG, with the data-uri prefix added
              //this.imageUrl = image.dataUrl
              //var imgB64 = this.imageUrl.replace("data:image/png;base64,", "");
              var imgB64 = image.base64String

              // If location is turned off
              if(!this.location["lat"])
                this.location["lat"] = 0

              if (!this.location["long"])
                this.location["long"] = 0

              self.$router.push({name:"SendCheckin", 
                                 params: { "deviceUserToken": self.deviceUserToken,
                                           "userId": self.userId.trim(),
                                           "imgB64": imgB64,
                                           "lat": this.location["lat"],
                                           "long": this.location["long"],
                                         } 
                               })

            } catch (e) {
              console.log("error", e)
            }
          }
        },

    async validateUserId(){
      var self = this

      if (this.userId.trim()==""){
        alert("Please provide User Id.")
        return
      }

      if (this.$parent.onlineStatus == 'OffLine'){
        console.log("Offline")
        //self.$alert("No internet connection. Please try after some time.")
        // return
        self.takePicture()
      }
      else {
        console.log("Online")
        firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            user.getIdToken().then(token => {
                        //handle token
                        self.deviceUserToken = token
                        this.postValidateUserId(self.deviceUserToken, self.userId.trim())
                      })
          } else {
            this.$router.push('/login')
          }
        })
      }

    },

    async postValidateUserId(deviceUserToken, userId){
      var self = this

      // Set loading message
      self.loading = true
      self.goBackDisabled = true

      var postData = new FormData()
      postData.append("userId", userId)

      axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_ROOT_API,
          url: '/ValidateUserId/',
          data: postData,
          headers: {
            'Authorization': 'Bearer ' + deviceUserToken,
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        })
        .then(function (response) {
          // Reset loading message
          self.loading = false
          if (response.data.err != '') {
            console.log(response.data.err)
            self.$alert(response.data.err)
          }
          else {
            self.takePicture()
          }
        })
        .catch(function (error) {
          // Reset loading message
          self.loading = false
          console.log(String(error))
          self.$alert(String(error))
        })

    },

    },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
